module.exports = __webpack_public_path__ + "img/fun01.ed48cfc0.png";